import { Button, Flex, Modal, Text } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { usePostApi } from "src/hooks";

import NotCompletedEntriesModal from "../NotCompletedEntriesModal/NotCompletedEntriesModal";

interface IConfirmReviewCompletion {
  opened: boolean;
  close: () => void;
  onSuccess: () => void;
}

const ConfirmReviewCompletion = ({
  opened,
  close,
  onSuccess,
}: IConfirmReviewCompletion) => {
  const [notCompletedEntries, setNotCompletedEntries] = useState();
  const [
    openedNotCompletedEntriesModal,
    {
      open: openNotCompletedEntriesModal,
      close: closeNotCompletedEntriesModal,
    },
  ] = useDisclosure(false);
  const { aid } = useParams();
  const { post } = usePostApi();

  const handleYes = async () => {
    await post({
      request: "mark-review-complete",
      body: { params: { aid } },
      onSuccess: async res => {
        if (res?.count) {
          openNotCompletedEntriesModal();
          setNotCompletedEntries(res.count);
        } else {
          closeNotCompletedEntriesModal();
          close();
          onSuccess();
        }
      },
    });
  };

  return (
    <>
      <NotCompletedEntriesModal
        opened={openedNotCompletedEntriesModal}
        close={closeNotCompletedEntriesModal}
        notCompletedEntriesNumber={notCompletedEntries}
      />
      <Modal
        opened={opened}
        onClose={close}
        title="Complete Review"
        size="40vw"
        yOffset={"10dvw"}
        zIndex={1000}>
        <Flex w={"100%"} justify={"center"}>
          <Text>Are you sure you are ready to complete the review?</Text>
        </Flex>
        <Flex mt={10} h={"100%"} w={"100%"} justify={"center"} gap={10}>
          <Button onClick={handleYes}>Yes</Button>
          <Button onClick={close}>No</Button>
        </Flex>
      </Modal>
    </>
  );
};

export default ConfirmReviewCompletion;
